module.exports = __webpack_public_path__ + "img/cambria_logo.f909cf20.png";